import { PrivacyPolicy } from "../components/PrivacyPolicy";

export function PrivacyPolicyPage() {
  return (
    <main id="main-content" tabIndex={-1}>
      <PrivacyPolicy mode="page" />
    </main>
  );
}
